/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { isNotEmpty, noop } from "~/tools";
import { EstateFilterHeader } from "../Filters/EstateFilterHeader";
import { MultiTagsInput } from "./MultiTagsInput";

type Props = {
  inputTags?: string[];
  onChange: (tags: string[]) => void;
  placeholderName: string;
};

export function EstateMultiTagsInput({
  inputTags,
  onChange,
  placeholderName,
}: Props) {
  return (
    <>
      <EstateFilterHeader onSetSearch={noop} />
      <MultiTagsInput
        showIcon
        inputTags={isNotEmpty(inputTags ?? []) ? inputTags : [""]}
        width="14rem"
        placeholder={{
          key: `${placeholderName} Key`,
          value: `${placeholderName} Value`,
        }}
        onChange={onChange}
      />
    </>
  );
}
